(() => {
  function init() {
    window.park.eventHub.register('click', '.park-authorsbox-premium__collapse-toggle', (el) => {
      const authorBox = el.target.closest('.park-authorsbox-premium');
      const authorBio = authorBox.querySelector('.park-authorsbox-premium__bio-wrapper');

      if (!authorBox || !authorBio) {
        return;
      }

      authorBox.classList.toggle('park-authorsbox-premium--collapsed');

      if (authorBio.style.maxHeight) {
        authorBio.style.maxHeight = null;
      } else {
        authorBio.style.maxHeight = `${authorBio.scrollHeight}px`;
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  }
})();
